import { useEffect, useState } from "react";

import "./App.css";
import logo from "./img/logo.png";
import carbon from "./img/carbon.svg";
import testify from "./img/testify.png";

import og5 from "./img/og5.jpeg";
import og4 from "./img/og4.jpg";
import og3 from "./img/og3.jpeg";
import og2 from "./img/og2.jpeg";
import og1 from "./img/og1.jpeg";
import sa from "./img/sa.jpg";
import sa2 from "./img/sa2.jpeg";
import f1 from "./img/f1.jpeg";
import f2 from "./img/f2.jpeg";
import f3 from "./img/f3.jpeg";
import f4 from "./img/f4.jpg";
import f5 from "./img/f5.jpg";
import f6 from "./img/f6.jpeg";
import it_woman from "./img/it_woman.jpg";
import ks_limited from "./img/ks-motels-limited1.jpg";
import ks_limited2 from "./img/ks-motels-limited2.jpg";
import gdIbadan from "./img/gdIbadan.jpg";

import swal from "sweetalert";

// import { PaystackButton } from "react-paystack";

function App() {
 const [dayDOM, setDayDOM] = useState();
 const [hourDOM, setHourDOM] = useState();
 const [minDOM, setMinDOM] = useState();
 const [secDOM, setSecDOM] = useState();

 const [individualFirstName, setIndividualFirstName] = useState("");
 const [individualLastName, setIndividualLastName] = useState("");
 const [individualEmail, setIndividualEmail] = useState("");
 const [isIndividualEmailValid, setIsIndividualEmailValid] = useState(false);
 const [individualPhone, setIndividualPhone] = useState("");
 const [individualAddress, setIndividualAddress] = useState("");
 const [individualGender, setIndividualGender] = useState("");
 const [individualEducation, setIndividualEducation] = useState("");

 const [organizationName, setOrganizationName] = useState("");
 const [organizationEmail, setOrganizationEmail] = useState("");
 const [isOrganizationEmailValid, setIsOrganizationEmailValid] =
  useState(false);
 const [organizationPhone, setOrganizationPhone] = useState("");
 const [organizationApplicationNumber, setOrganizationApplicationNumber] =
  useState(1);
 const [organizationCandidatesEmail, setOrganizationCandidatesEmail] =
  useState("");
 const [modal, setModal] = useState(false);
 const [loader, setLoader] = useState(false);
 const [validIndividual, setValidIndividual] = useState(false);
 const [validOrganization, setValidOrganization] = useState(false);
 const [bringBackToTop, setBringBackToTop] = useState(false);

 //Dealines
 const [deadline, setDeadline] = useState(false);
 const [timerEnded, setTimerEnded] = useState(false);

 // const btnModal = document.querySelectorAll(".btn-modal");
 const individualModal = document.querySelector(".individual-modal");
 const organizationModal = document.querySelector(".organization-modal");

 useEffect(() => {
  const now = new Date();
  const d = new Date("December 5, 2021 12:00:00");
  const deadline = Date.parse(d);
  const result = deadline - now;
  if (result <= 0) {
   setDeadline(true);
  }
 }, []);
 //Fucntion that calculates the number of days, hours, mins, and sec that is remianing b4 another new year
 const myFunction = () => {
  //DOM elements
  let date = new Date();
  let newYear = new Date("December 17, 2021");
  let dateParse = Date.parse(date);
  let newYearParse = Date.parse(newYear);
  let difference = newYearParse - dateParse;
  const day = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hour = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const min = Math.floor((difference / (1000 * 60)) % 60);
  const sec = Math.floor((difference / 1000) % 60);

  //Outputting to the DOM
  setDayDOM(day);
  setHourDOM(addZero(hour));
  setMinDOM(addZero(min));
  setSecDOM(addZero(sec));
 };

 //Calling of myFunction function using setInterval
 const timer = setInterval(myFunction, 1000);

 useEffect(() => {
  const now = new Date();
  const d = new Date("December 17, 2021");
  const deadline = Date.parse(d);
  const result = deadline - now;
  if (result <= 0) {
   setTimerEnded(true);
   clearInterval(timer);
  }
 }, [timer]);

 // When the user clicks anywhere outside of the modal, don't close it
 window.onClick = function (event) {
  if (event.target === modal) {
   modal.style.display = "block";
  }
 };

 const openModal = () => {
  setModal(true);
 };

 const registerIndividual = () => {
  organizationModal.style.display = "none";
  openModal();
  individualModal.style.display = "block";
 };

 const registerOrganization = () => {
  individualModal.style.display = "none";
  openModal();
  organizationModal.style.display = "block";
 };

 const handleEducation = (e) => {
  setIndividualEducation(e.target.value);
 };

 const handleGender = (e) => {
  setIndividualGender(e.target.value);
 };

 //Function to add zero before numbers below 10
 const addZero = (e) => {
  return e < 10 ? "0" + e : "" + e;
 };

 const validateIndividualEmail = () => {
  const email = { email: individualEmail };
  fetch("https://stify.herokuapp.com/api/v1/users/validate-email", {
   method: "POST",
   headers: {
    "Content-Type": "application/json",
   },
   body: JSON.stringify(email),
  })
   .then((data) => {
    return data.json();
   })
   .then((res) => {
    setIsIndividualEmailValid(Boolean(res.error));
   })
   .catch((err) => {
    console.log(err.message);
   });
 };

 const validateOrganizationEmail = () => {
  const email = { email: organizationEmail };
  fetch("https://stify.herokuapp.com/api/v1/users/validate-email", {
   method: "POST",
   headers: {
    "Content-Type": "application/json",
   },
   body: JSON.stringify(email),
  })
   .then((data) => {
    return data.json();
   })
   .then((res) => {
    setIsOrganizationEmailValid(Boolean(res.error));
   })
   .catch((err) => {
    console.log(err.message);
   });
 };

 useEffect(() => {
  if (
   individualAddress === "" ||
   individualEducation === "" ||
   individualEmail === "" ||
   individualGender === "" ||
   individualPhone === "" ||
   individualLastName === "" ||
   individualFirstName === "" ||
   isIndividualEmailValid
  ) {
   setValidIndividual(false);
  } else {
   setValidIndividual(true);
  }
 }, [
  individualAddress,
  individualFirstName,
  individualGender,
  individualLastName,
  individualPhone,
  individualEmail,
  individualEducation,
  isIndividualEmailValid,
 ]);

 useEffect(() => {
  if (
   organizationCandidatesEmail === "" ||
   organizationEmail === "" ||
   organizationPhone === "" ||
   organizationName === "" ||
   organizationApplicationNumber === "" ||
   isOrganizationEmailValid
  ) {
   setValidOrganization(false);
  } else {
   setValidOrganization(true);
  }
 }, [
  organizationEmail,
  organizationName,
  organizationPhone,
  organizationCandidatesEmail,
  organizationApplicationNumber,
  isOrganizationEmailValid,
 ]);

 const individualBody = {
  type: "individual",
  firstName: individualFirstName,
  lastName: individualLastName,
  email: individualEmail,
  phoneNumber: individualPhone,
  numberOfApplications: 1,
  candidatesEmail: individualEmail,
  location: individualAddress,
  educationLevel: individualEducation,
  gender: individualGender,
 };

 // const individualComponentProps = {
 //   email: individualEmail,
 //   amount: 5000 * 100,
 //   metadata: {
 //     phone: individualPhone,
 //   },
 //   publicKey: process.env.REACT_APP_PAYSTACK,
 //   text: "Pay Now",
 //   onSuccess: () => {
 //     setLoader(true);
 //     fetch("https://stify.herokuapp.com/api/v1/users/register", {
 //       method: "POST",
 //       headers: {
 //         "Content-Type": "application/json",
 //       },
 //       body: JSON.stringify(individualBody),
 //     })
 //       .then((res) => {
 //         if (res.ok) {
 //           setLoader(false);
 //           setModal(false);

 //           swal({
 //             title: "Congratulations!",
 //             icon: "success",
 //             text: " You have successfully registered for Hunt de' Bug Bootcamp. Click the button below to join Hunt De' Bug Bootcamp Whatsapp group",
 //             button: "Join Group",
 //             dangerMode: false,
 //             closeOnClickOutside: false,
 //             closeOnEsc: false,
 //           }).then((join) => {
 //             if (join) {
 //               window.location.assign("https://bit.ly/WelcomeToHuBB");
 //             }
 //           });
 //         } else {
 //           setLoader(false);
 //           swal("Oops!", "An error occurred, please try again", "error");
 //         }
 //       })
 //       .catch((err) => {
 //         setLoader(false);
 //         if (err.message === "Failed to fetch") {
 //           swal(
 //             "Oops!",
 //             "Please check your internet connection and try again",
 //             "error"
 //           );
 //         } else {
 //           setLoader(false);
 //           swal("Oops!", "Your registration was unsuccessful", "error");
 //         }
 //       });
 //   },

 //   onClose: () => swal("Oops!", "Transaction was unsuccessful", "error"),
 // };

 //organization
 const candidatesEmail = organizationCandidatesEmail?.split(",");
 const organizationBody = {
  type: "group",
  firstName: organizationName,
  lastName: "",
  email: organizationEmail,
  phoneNumber: organizationPhone,
  numberOfApplications: organizationApplicationNumber,
  candidatesEmails: candidatesEmail,
 };

 //paystack props
 // const organizationComponentProps = {
 //   email: organizationEmail,
 //   amount: organizationApplicationNumber * (5000 * 100),
 //   metadata: {
 //     phone: organizationPhone,
 //   },
 //   publicKey: process.env.REACT_APP_PAYSTACK,
 //   text: "Pay Now",
 //   onSuccess: () => {
 //     setLoader(true);
 //     fetch("https://stify.herokuapp.com/api/v1/users/register", {
 //       method: "POST",
 //       headers: {
 //         "Content-Type": "application/json",
 //       },
 //       body: JSON.stringify(organizationBody),
 //     })
 //       .then((res) => {
 //         if (res.ok) {
 //           setLoader(false);
 //           setModal(false);

 //           swal({
 //             title: "Congratulations!",
 //             icon: "success",
 //             text: " You have successfully registered your candidates for Hunt De' Bug Bootcamp. Click the button below to join Hunt De' Bug Bootcamp Whatsapp group",
 //             button: "Join Group",
 //             dangerMode: false,
 //             closeOnClickOutside: false,
 //             closeOnEsc: false,
 //           }).then((join) => {
 //             if (join) {
 //               window.location.assign("https://bit.ly/WelcomeToHuBB");
 //             }
 //           });
 //         } else {
 //           setLoader(false);
 //           swal("Oops!", "An error occured, please try again", "error");
 //         }
 //       })
 //       .catch((err) => {
 //         setLoader(false);
 //         if (err.message === "Failed to fetch") {
 //           swal(
 //             "Oops!",
 //             "Please check your internet connection and try again",
 //             "error"
 //           );
 //         } else {
 //           setLoader(false);
 //           swal("Oops!", "Your registration was unsuccessful", "error");
 //         }
 //       });
 //   },

 //   onClose: () => swal("Oops!", "Transaction was unsuccessful", "error"),
 // };

 //toggler
 function toggleSidebar() {
  document.querySelector(".sidebar").classList.toggle("toggle-output");
 }

 // When the user scrolls down 20px from the top of the document, show the button
 window.onscroll = function () {
  scrollFunction();
 };

 function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
   setBringBackToTop(true);
  } else {
   setBringBackToTop(false);
  }
 }

 // When the user clicks on the button, scroll to the top of the document
 function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
 }

 // Submit
 const submitIndividual = (e) => {
  e.preventDefault();
  setLoader(true);
  fetch("https://stify.herokuapp.com/api/v1/users/register", {
   method: "POST",
   headers: {
    "Content-Type": "application/json",
   },
   body: JSON.stringify(individualBody),
  })
   .then((res) => {
    if (res.ok) {
     setLoader(false);
     setModal(false);

     swal({
      title: "Congratulations!",
      icon: "success",
      text:
       " You have successfully registered for Hunt de' Bug Bootcamp. Click the button below to join Hunt De' Bug Bootcamp Whatsapp group",
      button: "Join Group",
      dangerMode: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
     }).then((join) => {
      if (join) {
       window.location.assign("https://bit.ly/WelcomeToHuBB");
      }
     });
    } else {
     setLoader(false);
     swal("Oops!", "An error occurred, please try again", "error");
    }
   })
   .catch((err) => {
    setLoader(false);
    if (err.message === "Failed to fetch") {
     swal(
      "Oops!",
      "Please check your internet connection and try again",
      "error"
     );
    } else {
     setLoader(false);
     swal("Oops!", "Your registration was unsuccessful", "error");
    }
   });
 };

 const submitOrganization = (e) => {
  e.preventDefault();
  setLoader(true);
  fetch("https://stify.herokuapp.com/api/v1/users/register", {
   method: "POST",
   headers: {
    "Content-Type": "application/json",
   },
   body: JSON.stringify(organizationBody),
  })
   .then((res) => {
    if (res.ok) {
     setLoader(false);
     setModal(false);

     swal({
      title: "Congratulations!",
      icon: "success",
      text:
       " You have successfully registered your candidates for Hunt De' Bug Bootcamp. Click the button below to join Hunt De' Bug Bootcamp Whatsapp group",
      button: "Join Group",
      dangerMode: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
     }).then((join) => {
      if (join) {
       window.location.assign("https://bit.ly/WelcomeToHuBB");
      }
     });
    } else {
     setLoader(false);
     swal("Oops!", "An error occured, please try again", "error");
    }
   })
   .catch((err) => {
    setLoader(false);
    if (err.message === "Failed to fetch") {
     swal(
      "Oops!",
      "Please check your internet connection and try again",
      "error"
     );
    } else {
     setLoader(false);
     swal("Oops!", "Your registration was unsuccessful", "error");
    }
   });
 };

 // accordion
 const [isShowing, setIsShowing] = useState([
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
 ]);
 const toggleShow = (index) => {
  setIsShowing(
   isShowing.map((it, j) => {
    if (j === index) {
     console.log(it);
     return !it;
    } else {
     return it;
    }
   })
  );
 };
 return (
  <div className="App">
   <div
    id="myModal"
    className="modal"
    style={{ display: modal ? "block" : "none" }}
   >
    <div className="modal-content">
     <span
      className="close"
      onClick={() => {
       setModal(false);
      }}
     >
      ×
     </span>
     <div className="modal-inner-content">
      <div className="individual-modal">
       <p className="bold" style={{ color: "#13529f" }}>
        Individual
       </p>
       <form
        action=""
        name="individual-form"
        id="individual-form"
        onSubmit={submitIndividual}
       >
        <div style={{ marginTop: "10px" }}>
         <div className="flex">
          <label htmlFor="name">First Name</label>
          <input
           className="input individual-firstname"
           name="name"
           type="text"
           placeholder="Your First Name"
           required
           value={individualFirstName}
           onChange={(e) => {
            setIndividualFirstName(e.target.value);
           }}
          />
          <br />
         </div>
         <div className="flex">
          <label htmlFor="name">Last Name</label>
          <input
           className="input individual-lastname"
           name="name"
           type="text"
           placeholder="Your Last Name"
           required
           value={individualLastName}
           onChange={(e) => {
            setIndividualLastName(e.target.value);
           }}
          />
          <br />
         </div>

         <div className="flex">
          <label htmlFor="email">Email</label>
          <input
           className="input individual-email"
           name="email"
           type="email"
           placeholder="Your Email Address"
           required
           value={individualEmail}
           onChange={(e) => {
            setIndividualEmail(e.target.value);
           }}
           onBlur={() => {
            validateIndividualEmail();
           }}
          />
          <div className="flex">
           <span
            className="email-error"
            style={{
             display: isIndividualEmailValid ? "block" : "none",
            }}
           >
            This email has already been registered
           </span>
          </div>
          <br />
         </div>

         <div className="flex">
          <label htmlFor="phone">Phone</label>
          <input
           className="input individual-phone"
           name="phone"
           type="tel"
           placeholder="Phone Number"
           required
           value={individualPhone}
           onChange={(e) => {
            setIndividualPhone(e.target.value);
           }}
          />
          <br />
         </div>

         <div className="flex">
          <label htmlFor="address">Location</label>
          <input
           className="input individual-location"
           name="address"
           type="text"
           placeholder="Eg. Ibadan, Asaba"
           required
           value={individualAddress}
           onChange={(e) => {
            setIndividualAddress(e.target.value);
           }}
          />
          <br />
         </div>

         <div className="flex">
          <label htmlFor="education">Education</label>
          <div style={{ display: "block", marginBottom: "10px" }}>
           <div className="radio-container">
            <input
             type="radio"
             name="education"
             value="o'level"
             id="o'level"
             onChange={handleEducation}
            />
            <span className="opt">O'level</span>
           </div>
           <div className="radio-container">
            <input
             type="radio"
             name="education"
             value="undergraduate"
             id="undergraduate"
             onChange={handleEducation}
            />
            <span className="opt">Undergraduate</span>
           </div>

           <div className="radio-container">
            <input
             type="radio"
             name="education"
             value="graduate"
             id="graduate"
             onChange={handleEducation}
            />
            <span className="opt">Graduate</span>
           </div>
          </div>
         </div>

         <div className="flex">
          <label htmlFor="education">Gender</label>
          <div style={{ display: "block", marginBottom: "10px" }}>
           <div className="radio-container">
            <input
             type="radio"
             name="gender"
             value="male"
             id="male"
             onChange={(e) => handleGender(e)}
            />
            <span className="opt">Male</span>
           </div>

           <div className="radio-container">
            <input
             type="radio"
             name="gender"
             value="female"
             id="female"
             onChange={(e) => handleGender(e)}
            />
            <span className="opt">Female</span>
           </div>
          </div>
         </div>

         <div
          id="loader-individual"
          style={{
           marginTop: "10px",
           display: loader ? "block" : "none",
          }}
         >
          <i
           style={{ color: "#ec008c" }}
           className="fa fa-spinner fa-spin fa-2x"
           aria-hidden="true"
          ></i>
         </div>

         {!validIndividual && (
          <button className="paystack-button disable" disabled>
           Register Now
          </button>
         )}
         {validIndividual && (
          // <PaystackButton
          //   className="paystack-button"
          //   {...individualComponentProps}
          // />
          <button className="paystack-button">Register Now</button>
         )}
        </div>
       </form>
      </div>

      <div className="organization-modal">
       <p className="bold" style={{ color: "#13529f" }}>
        Organization
       </p>
       <form action="" id="organization-form" onSubmit={submitOrganization}>
        <div style={{ marginTop: "10px" }}>
         <div className="flex">
          <label htmlFor="name">Name</label>
          <input
           className="input organization-name"
           name="name"
           type="text"
           placeholder="Organization's Name"
           required
           value={organizationName}
           onChange={(e) => {
            setOrganizationName(e.target.value);
           }}
          />
          <br />
         </div>

         <div className="flex">
          <label htmlFor="email">Email</label>
          <input
           className="input organization-email"
           name="email"
           type="email"
           placeholder="Organization's Email "
           required
           value={organizationEmail}
           onChange={(e) => {
            setOrganizationEmail(e.target.value);
           }}
           onBlur={() => {
            validateOrganizationEmail();
           }}
          />
          <div className="flex">
           <span
            className="email-error"
            style={{
             display: isOrganizationEmailValid ? "block" : "none",
            }}
           >
            This email has already been registered
           </span>
          </div>
          <br />
         </div>

         <div className="flex">
          <label htmlFor="phone">Phone</label>
          <input
           className="input organization-phone"
           name="phone"
           type="tel"
           placeholder="Organization's Phone Number"
           required
           value={organizationPhone}
           onChange={(e) => {
            setOrganizationPhone(e.target.value);
           }}
          />
          <br />
         </div>

         <div className="flex">
          <label htmlFor="number">Number of application</label>
          <input
           value={organizationApplicationNumber}
           className="input candidates-number"
           name="number"
           type="number"
           placeholder="Number of candidates"
           required
           onChange={(e) => {
            setOrganizationApplicationNumber(e.target.value);
           }}
          />
          <br />
         </div>

         <div className="flex">
          <label
           htmlFor="input candidates-email"
           value={organizationCandidatesEmail}
           onChange={(e) => {
            setOrganizationCandidatesEmail(e.target.value);
           }}
          >
           Candidates Information (Emails)
          </label>
          <textarea
           className="candidates-email"
           name="candidates-email"
           id=""
           cols="20"
           rows="4"
           placeholder="Emails separated by coma"
           value={organizationCandidatesEmail}
           onChange={(e) => {
            setOrganizationCandidatesEmail(e.target.value);
           }}
          ></textarea>
         </div>

         <div
          id="loader-organization"
          style={{
           marginTop: "20px",
           display: loader ? "block" : "none",
          }}
         >
          <i
           style={{ color: "#ec008c" }}
           className="fa fa-spinner fa-spin fa-2x"
           aria-hidden="true"
          ></i>
         </div>

         {!validOrganization && (
          <button className="paystack-button disable" disabled>
           Register
          </button>
         )}

         {validOrganization && (
          // <PaystackButton
          //   className="paystack-button"
          //   {...organizationComponentProps}
          // />
          <button className="paystack-button">Register</button>
         )}
        </div>
       </form>
      </div>
     </div>
    </div>
   </div>

   <button
    onClick={topFunction}
    style={{ display: bringBackToTop ? "block" : "none" }}
    id="myBtn"
    title="Go to top"
   >
    <i className="fa fa-arrow-up fa-1x" aria-hidden="true"></i>
   </button>

   <div className="container">
    <div className="overlay">
     <div className="sidebar">
      <a className="smooth-scroll" href="#register" onClick={toggleSidebar}>
       Register
      </a>
      <a className="smooth-scroll" href="#sponsors" onClick={toggleSidebar}>
       Sponsors
      </a>
     </div>

     <div className="content">
      <nav className="nav">
       <div className="brand">
        <p className="brand-name">
         <img src={logo} height="10" width="10" alt="logo" />
        </p>
       </div>
       <div
        id="toggler"
        onClick={() => {
         toggleSidebar();
        }}
       >
        <span id="togglerbar">
         <i className="fa fa-bars"></i>
        </span>
       </div>

       <div className="desktop-nav">
        <a className="smooth-scroll" href="#register">
         Register
        </a>

        <a className="smooth-scroll" href="#sponsors">
         Sponsors
        </a>
        <a
         href="https://web.facebook.com/testify.org"
         rel="noreferrer"
         target="_blank"
        >
         Community
        </a>
       </div>
      </nav>

      <div className="wrapper">
       <div className="date">
        <span className="date-text">17th - 18th December</span>
       </div>

       <div className="main">
        <h1 className="main-text">Hunt de' Bug Bootcamp</h1>
        <p className="main-description">
         Looking forth to break into tech? Hunt de' Bug Bootcamp will bring you
         to speed with the necessary employable IT Skill with or without your IT
         Background.
        </p>
       </div>

       <div className="countdown">
        <div className="countdown-content">
         <span id="day" className="countdown-value">
          {!timerEnded && dayDOM}
          {timerEnded && "00"}
         </span>
         <span>Days</span>
        </div>
        <div className="countdown-content">
         <span id="hour" className="countdown-value">
          {!timerEnded && hourDOM}
          {timerEnded && "00"}
         </span>
         <span>Hours</span>
        </div>
        <div className="countdown-content">
         <span id="min" className="countdown-value">
          {!timerEnded && minDOM}
          {timerEnded && "00"}
         </span>
         <span>Minutes</span>
        </div>
        <div className="countdown-content">
         <span id="sec" className="countdown-value">
          {!timerEnded && secDOM}
          {timerEnded && "00"}
         </span>
         <span>Seconds</span>
        </div>
       </div>
       <div className="cta-container">
        <a
         href="#register"
         className="smooth-scroll btn"
         style={{ display: !deadline ? "block" : "none" }}
        >
         Register Now
        </a>
        <p style={{ display: !deadline ? "none" : "block" }}>
         Registration has ended
        </p>
       </div>
      </div>
     </div>
    </div>
   </div>

   <div className="accordion-content">
    <div className="row">
     <div className="accordion-inner">
      <p>
       Are you passionate about breaking into the tech world even though you
       don't have an IT background?
      </p>
      <br />
      <p className="semi-bold" style={{ textAlign: "justify" }}>
       On December 17th, Testify and Carbon will come together in Ibadan to host
       the first maiden Hunt de' Bug Bootcamp. At this Bootcamp, you will be
       opportune to learn an in-demand employable IT skill as well as
       demonstrate what you have learned by working on actual company products.{" "}
       <br />
       <br />
       Our Bootcamp intensive training will kick off on Friday morning at 9:00
       am and last until 8:30 pm. We will break for the evening and resume for
       day two on Saturday morning at 9:00 am. Throughout the two days, we will
       have mentors, food, and fun to keep you fuelled and help you gain an
       in-depth understanding of this skill. The goal of the Bootcamp is to help
       you kick start your IT career journey by providing you a soft landing
       even if you don't have any idea about any tech career before now.
       <br />
       <br />
       Unfortunately, we are unable to provide overnight accommodation in
       Ibadan, but we will provide transportation to designated drop-off areas
       within the city and around <br />
       <br />
      </p>
     </div>
     <div className="accordion-inner">
      <div className="accordion-img-container">
       <img src={it_woman} alt="img" />
      </div>
     </div>
    </div>
   </div>

   <div
    className="accordion-container "
    style={{
     padding: "30px 10px",
    }}
   >
    <p
     className="bold"
     style={{
      color: "#13529f",
      textAlign: "center",
      marginBottom: "10px",
     }}
    >
     Programme Details
    </p>
    <div class="accordion" onClick={() => toggleShow(0)}>
     <p style={{ fontWeight: "400" }}> HuBB'21 Date, Venue and Location</p>
     <p>
      {" "}
      {isShowing[0] && <i className="fa fa-minus" aria-hidden="true"></i>}
      {!isShowing[0] && <i className="fa fa-plus" aria-hidden="true"></i>}
     </p>
    </div>
    {isShowing[0] && (
     <div className="accordion-panel">
      <div className="child">
       <i
        className="fa fa-calendar fa-2x"
        style={{ color: "#ec008c" }}
        aria-hidden="true"
       ></i>

       <p>17th and 18th December, 2021</p>
      </div>

      <div className="child">
       <div>
        <i
         class="fa fa-map-marker fa-2x"
         style={{ color: "#ec008c" }}
         aria-hidden="true"
        ></i>
        <p>
         KS MOTEL LIMITED, Ibadan. Address: Queen Elizabeth Rd, Agodi 200285,
         Ibadan
        </p>
        <div className="row">
         <div className="accordion-inner-location">
          <img src={ks_limited} alt="img" height="100%" width="100%" />
         </div>
         <div className="accordion-inner-location">
          <img src={ks_limited2} alt="img" height="100%" width="100%" />
         </div>
        </div>
       </div>
      </div>

      <div className="child map">
       <iframe
        src="https://www.google.com/maps/d/embed?mid=1Dn05jKVkkFO-1pMcELzTKW1hPWU&hl=en"
        width="100%"
        height="100%"
        title="KS MOTEL LIMITED, Ibadan. Address: Queen Elizabeth Rd, Agodi
                200285, Ibadan"
       >
        Loading...
       </iframe>
      </div>
     </div>
    )}

    <div class="accordion" onClick={() => toggleShow(1)}>
     <p style={{ fontWeight: "400" }}>Contact Details</p>
     <p>
      {" "}
      {isShowing[1] && <i className="fa fa-minus" aria-hidden="true"></i>}
      {!isShowing[1] && <i className="fa fa-plus" aria-hidden="true"></i>}
     </p>
    </div>
    {isShowing[1] && (
     <div className="accordion-panel">
      <div className="child">
       <p style={{ fontSize: "24px" }}>
        Email:{" "}
        <a
         className="accordion-btn"
         href="mailto: motunrayo@testifyltd.com"
         style={{ fontSize: "24px" }}
        >
         motunrayo@testifyltd.com
        </a>
       </p>
      </div>
      <div className="child">
       <p>
        {" "}
        You can contact us via our social media platforms
        Facebook/Instagram/Twitter
       </p>
       <p className="semi-bold" style={{ fontSize: "24px" }}>
        <i className="fa fa-whatsapp" style={{ color: "#ec008c" }}></i>
        +2349058820971
       </p>
       <div className="footer-contact accordion-contact">
        <a
         target="_blank"
         href="https://twitter.com/Testify_org"
         rel="noreferrer"
         style={{ color: "#13529f" }}
        >
         <i className="fa fa-twitter fa-2x"></i>
        </a>
        <a
         target="_blank"
         href="https://www.instagram.com/testify_org"
         rel="noreferrer"
        >
         <i className="fa fa-instagram fa-2x"></i>
        </a>
        <a
         target="_blank"
         href="https://web.facebook.com/testify.org"
         rel="noreferrer"
        >
         <i className="fa fa-facebook fa-2x"></i>
        </a>
        <a
         target="_blank"
         href="https://www.linkedin.com/company/testifyorg"
         rel="noreferrer"
        >
         <i className="fa fa-linkedin fa-2x"></i>
        </a>
        <a
         target="_blank"
         href="https://www.youtube.com/channel/UCsc5CAujtHOMBJcZg7L4yTg"
         rel="noreferrer"
        >
         <i className="fa fa-youtube fa-2x"></i>
        </a>
       </div>
      </div>
     </div>
    )}

    <div class="accordion" onClick={() => toggleShow(2)}>
     <p style={{ fontWeight: "400" }}>Meet Our Facilitators and Speakers</p>
     <p>
      {" "}
      {isShowing[2] && <i className="fa fa-minus" aria-hidden="true"></i>}
      {!isShowing[2] && <i className="fa fa-plus" aria-hidden="true"></i>}
     </p>
    </div>
    {isShowing[2] && (
     <div className="accordion-panel">
      <div className="child divider">
       <div>
        <p
         className="semi-bold"
         style={{
          color: "#ec008c",
          fontSize: "25px",
          textAlign: "center",
         }}
        >
         Honourable Dignitaries
        </p>
        <div className="row">
         <div className="accordion-inner">
          <img className="speaker" src={sa} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Adebayo Akande</p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Special Assistant to Oyo State Governor on ICT and EGovernance
          </p>
          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/adebayo-akande-7088aa183/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row" style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={sa2} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Olubunmi (Banjo) Fajuyigbe</p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Founder of She Learns Here
          </p>
          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/olubunmi-fajuyigbe/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child divider">
       <div>
        <p
         className="semi-bold"
         style={{
          color: "#ec008c",
          fontSize: "25px",
          textAlign: "center",
         }}
        >
         Facilitators
        </p>
        <div className="row">
         <div className="accordion-inner">
          <img className="speaker" src={f1} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>
           {" "}
           Oluwatomilola (Okuboyejo) Familoni
          </p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Senior QA and Test Engineer, AZA
          </p>
          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/oluwatomifamiloni/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row" style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={f2} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Seyinfunmi Olaoye</p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Senior QA and Test Engineer, 54Gene
          </p>

          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/thatseyifunmi/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row" style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img
           className="speaker"
           width="800px"
           height="800px"
           src={f5}
           alt="img"
          />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Adewale Usman</p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Software Quality Assurance Engineer at Interswitch Group || Lean 6
           Sigma Y Belt || ISTQB Certified || Test Automation Engineer
          </p>
          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/usman-adewale/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row" style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={og2} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Lynda Nwakor</p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Program Manager/Quality Assurance Engineer at Tete Tech
          </p>
          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/nwakor-lynda-792811107/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row" style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={f4} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Temitope Adeleke</p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Software Quality Assurance Manager | Quality Assurance Engineer |
           Test Automation Consultant | Agile Practitioner | QA Trainer
          </p>
          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/temitope-omolere/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row" style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={f6} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Christianah Ajala</p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Software Tester | Credit Manager
          </p>
          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/ajala-christianah-eniola/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row" style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={f3} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Ibironke Yekinni</p>
          <p
           className="semi-bold"
           style={{
            color: "#ec008c",
            fontSize: "18px",
            textAlign: "center",
           }}
          >
           Senior Quality Assurance & Test Automation Engineer | Test Coach |
           Test Community Manager| WomenTechmaker Ambassador | CVO of Testify
           Limited
          </p>
          <p>
           {" "}
           <a
            href="https://www.linkedin.com/in/ibironke-yekinni/"
            rel="noreferrer"
            target="_blank"
           >
            <i
             className="fa fa-linkedin-square fa-2x"
             style={{
              color: "#ec008c",
             }}
            ></i>
           </a>
          </p>
         </div>
        </div>
       </div>
      </div>

      <div className="child divider">
       <div>
        <p
         className="semi-bold"
         style={{
          color: "#ec008c",
          fontSize: "25px",
          textAlign: "center",
         }}
        >
         Organizers
        </p>
        <div className="row ">
         <div className="accordion-inner">
          <img className="speaker" src={og1} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}> Mr. Esuong Jentle</p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row " style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={og3} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Ms. Tinah Peters</p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row " style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={og4} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Fasakin Motunrayo</p>
         </div>
        </div>
       </div>
      </div>

      <div className="child">
       <div>
        <div className="row " style={{ borderTop: "2px dotted black" }}>
         <div className="accordion-inner">
          <img className="speaker" src={og5} alt="img" />
         </div>
         <div className="accordion-inner">
          <p style={{ textAlign: "center" }}>Mrs. Alabi Ifeoluwa</p>
         </div>
        </div>
       </div>
      </div>
     </div>
    )}
   </div>

   <div
    style={{
     backgroundColor: "#ec008c",
     padding: "30px 15px",
    }}
   >
    <div className="maxWidth">
     <iframe
      width="100%"
      height="100%"
      src="https://www.youtube.com/embed/BiBSfIo1KhQ"
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
     ></iframe>
    </div>
   </div>

   <div
    className="section"
    id="register"
    style={{
     backgroundColor: "rgba(4, 25, 59, 0.8)",
     display: !deadline ? "block" : "none",
    }}
   >
    <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
     <span style={{ borderBottom: "2px solid #ec008c" }} className="bold">
      Register Now
     </span>
    </h1>
    <div className="semi-bold" style={{ textAlign: "left" }}>
     <p>
      <b style={{ color: "white", fontWeight: "500" }}>
       Other side attractions we have lined up are:
      </b>
     </p>{" "}
     <br />
     <ul>
      <li>Employable IT Skill (Valued at NGN500,000)</li>
      <li>
       the Internship opportunities for the participants that stand out (Valued
       at NGN300,000)
      </li>
      <li>A room filled with women for networking (Valued at NGN100,000)</li>
      <li>
       Souvenirs like T-shirts, Certificates, Notepad (Valued at NGN 15,000)
      </li>
      <li> Software Testing Manual. (Valued at NGN50,000)</li>
      <li>
       {" "}
       Games, competition, and enough food and drink to fuel your learning
       energy (Valued at NGN 15,000){" "}
      </li>
      <li>
       {" "}
       A community for continuous mentoring and learning after the program
       (Valued at NGN180,000)
      </li>
     </ul>
     <br />
     <b style={{ color: "white", fontWeight: "500" }}>
      The TOTAL VALUE: N1,160,000
     </b>{" "}
     <br />
    </div>
    <br />
    <p
     style={{
      color: "white",
      fontWeight: "300",
      alignItems: "justify",
     }}
    >
     <b style={{ color: "white", fontWeight: "500" }}> Guess What?</b> We Are In
     Celebration Mode, and We Love to Give, So we are giving you all For Free.
     You can secure your spot at this Bootcamp on or before December 5, 2021.
     However, Considering this is a Special Offer, the Spot is Limited. Yes, You
     Read That Right. It’s A Special Offer And It’s LIMITED Which Means We Will
     Close Out The Registration Before December 5th, 2021 Once We Reach Our
     Maximum Number Of Applicants. This is an Opportunity you don't want to miss
     out!
    </p>
    <br />
    <br />
    <p style={{ textAlign: "center" }}>
     <b style={{ color: "white", fontWeight: "500" }}>
      To register for this programme, select the type of application you want.
      Application is free{" "}
     </b>
    </p>
    <div className="content">
     <div className="card">
      <div className="register" onClick={registerIndividual}>
       <i className="fa fa-user fa-5x" aria-hidden="true"></i>
       <h1 className="bold">Individual</h1>
      </div>
     </div>
     <div className="card">
      <div className="register" onClick={registerOrganization}>
       <i className="fa fa-users fa-5x" aria-hidden="true"></i>
       <h1 className="bold">Organization</h1>
      </div>
     </div>
    </div>
   </div>
   <div className="section" style={{ backgroundColor: "#ddd" }}>
    <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
     <span
      style={{ color: "#13529f", borderBottom: "2px solid #ec008c" }}
      className="bold"
     >
      FAQs
     </span>
    </h1>
    <div className="faqs-container">
     <ol>
      <li className="faqs-li">
       <b> Is there accommodation?</b> <br /> No. See this like a full-day
       hackathon where you will be learning and implementing day and night.
       However, our venue is inside a hotel, hence you can lodge for as low as
       N8000naira /night on your expenses. You can pair a room with someone and
       get to pay as low as N4000 naira/night
      </li>
      <li className="faqs-li">
       <b>Is there Food and Drink?</b> <br /> Yes. We have more than enough food
       and drink for your tummy to carry 👏 during the two days of the program
      </li>
      <li className="faqs-li">
       <b>Is my transportation covered as well?</b> <br /> No, Our Venue is at
       the center heart of Ibadan. From either Iwo Road, Challenge or UI, Tell
       any bike man to take you to KS MOTEL @ Total Garden, Ibadan. It is
       opposite CAC Office.
      </li>
      <li className="faqs-li">
       <b>Can my company sponsor the event?</b> <br /> Yes of course. To sponsor
       or partner for the event, kindly contact us via bootcamp@testifyltd.comor
       contribute via:
       <a href="https://paystack.com/pay/hubb" style={{ color: "blue" }}>
        {" "}
        https://paystack.com/pay/hubb
       </a>{" "}
       and we will get in touch with you.
      </li>

      <li className="faqs-li">
       <b> I'm a male, can I signup?</b> <br />
       Yes, you can. However, there is no guarantee of selection upon
       registration. The team will review and give you an update, you might just
       be lucky!
      </li>
     </ol>
    </div>
   </div>
   <div
    className="section"
    id="sponsors"
    style={{ backgroundColor: "#f2f2f2" }}
   >
    <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
     <span
      style={{ borderBottom: "2px solid #ec008c", color: "#13529f" }}
      className="bold"
     >
      Sponsors and Partners
     </span>
    </h1>
    <marquee behavior="" direction="left" scrollamount="14">
     <div style={{ display: "flex", justifyContent: "space-evenly" }}>
      <a href="https://getcarbon.co" rel="noreferrer" target="_blank">
       {" "}
       <img
        style={{ marginRight: "20px" }}
        height="200px"
        width="300px"
        src={carbon}
        alt="sponsors"
       />
      </a>
      <a href="https://testifyltd.com" rel="noreferrer" target="_blank">
       <img
        style={{ marginRight: "20px" }}
        height="200px"
        width="300px"
        src={testify}
        alt="sponsors"
       />
      </a>

      <img
       style={{ marginRight: "20px" }}
       height="200px"
       width="300px"
       src={gdIbadan}
       alt="sponsors"
      />
     </div>
    </marquee>
   </div>

   <div className="section" id="footer" style={{ backgroundColor: "black" }}>
    <p className="bold" style={{ color: "#ec008c" }}>
     Contact Us
    </p>
    <div className="footer-container">
     <div className="footer-content semi-bold" style={{ textAlign: "left" }}>
      <span className="semi-bold" style={{ textAlign: "left" }}>
       <i className="fa fa-map-marker"></i> No 42, Ayoola Drive, Aare Bodija,
       Ibadan, Oyo State, Nigeria
      </span>
      <a
       href="tel: +2349058820971"
       className="semi-bold"
       style={{ textAlign: "left" }}
      >
       <i className="fa fa-phone"></i> +2349058820971
      </a>
      <a
       href="mailto:bootcamp@testifyltd.com"
       target="_blank"
       rel="noreferrer"
       className="semi-bold"
       style={{ textAlign: "left" }}
      >
       <i className="fa fa-envelope"></i> bootcamp@testifyltd.com
      </a>
     </div>
     <div className="footer-contact-container">
      <span className="semi-bold" style={{ textAlign: "center" }}>
       Social Media
      </span>
      <div className="footer-contact"></div>
      <div className="footer-contact">
       <a
        target="_blank"
        href="https://twitter.com/Testify_org"
        rel="noreferrer"
       >
        <i className="fa fa-twitter fa-2x"></i>
       </a>
       <a
        target="_blank"
        href="https://www.instagram.com/testify_org"
        rel="noreferrer"
       >
        <i className="fa fa-instagram fa-2x"></i>
       </a>
       <a
        target="_blank"
        href="https://web.facebook.com/testify.org"
        rel="noreferrer"
       >
        <i className="fa fa-facebook fa-2x"></i>
       </a>
       <a
        target="_blank"
        href="https://www.linkedin.com/company/testifyorg"
        rel="noreferrer"
       >
        <i className="fa fa-linkedin fa-2x"></i>
       </a>
       <a
        target="_blank"
        href="https://www.youtube.com/channel/UCsc5CAujtHOMBJcZg7L4yTg"
        rel="noreferrer"
       >
        <i className="fa fa-youtube fa-2x"></i>
       </a>
      </div>
     </div>
    </div>
    <h2 style={{ textAlign: "center" }} className="semi-bold">
     All Rights Reserved &copy; {new Date().getFullYear()}
    </h2>
   </div>
  </div>
 );
}

export default App;
